import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
  static values = {
    text: String,
    confirmText: { type: String, default: "Sim, aprovar" }
  }

  fire(event) {
    event.preventDefault()

    const isDark = document.documentElement.classList.contains("dark")

    Swal.fire({
      title: "Tem certeza?",
      text: this.textValue,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#059669",
      cancelButtonColor: "#dc2626",
      cancelButtonText: "Cancelar",
      confirmButtonText: this.confirmTextValue,
      background: isDark ? "#1f2937" : undefined,
      color: isDark ? "#f3f4f6" : undefined,
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.element.form.requestSubmit()
      }
    })
  }
}
